import {RemoteGetAuthStates} from 'data/usecases/private/authorizations';
import {GetAuthStates} from 'domain/usecases';
import {makeAuthorizeHttpClientDecorator} from 'main/factories/decorators';
import {makeBFFApiUrl} from 'main/factories/http';
import {AuthorizationsFlowEndpoints} from '../../endpoints';

export const makeGetAuthStates = (): GetAuthStates =>
	new RemoteGetAuthStates(
		makeBFFApiUrl(AuthorizationsFlowEndpoints.uf),
		makeAuthorizeHttpClientDecorator(),
	);
